export const externalUrlAdminTranslation = {

  // section title
  external_urls: 9404,

  // search
  search: 7345,
  search_hits: 7474,
  search_no_external_urls: 9416,

  // messages
  no_access_to_external_urls: 9417,
  external_url_deleted: 9418,
  external_url_updated: 9421,
  external_url_created: 9422,

  // list item
  disabled: 5251,
  delete_external_url_title: 9409,
  delete_external_url_button: 9408,
  column_url_template: 9410,
  column_description: 9411,

  // confirmation
  delete_confirmation: 9218,
  cancel: 9405,

  // prompt unsaved
  cancel_changes: 7558,
  are_you_sure: 7460,
  undo_all: 5792,
  go_back: 7966,

  // form messages
  external_url_validation_error: 8206,
  saving_external_url: 9419,
  deleting_external_url: 9420,

  // form header
  new_external_url: 9413,
  save: 9407,
  add_new: 6943,

  // form tabs
  switch_to_scroll: 7977,
  switch_to_tab: 7978,

  // sections
  details: 8044,
  descriptions_and_translations: 8391,
  visibility: 9603,
  visible_for_fields: 9604,
  no_options_found: 9605,
  loading: 9606,

  // language
  translations_header: 8364,
  show_translations: 8393,
  description: 7278,
  copy_description_to_all: 8386,
  copied_description_to_all: 8388,
  long_description: 9437,
  copy_long_description_to_all: 9438,
  copied_long_description_to_all: 9473,
  

  // validation
  must_be_filled_out: 5949
};

export type ExternalUrlAdminTranslation = {
  readonly [T in keyof typeof externalUrlAdminTranslation]: string
};
